export default __webpack_public_path__ + "static/media/logo.545e33d5.svg";